/**
 * EmptyState — Placeholder for empty content areas
 *
 * Used for: empty lists, no results, first-time states
 */
import type { ReactNode } from 'react'
import { styled, YStack, type GetProps } from 'tamagui'
import { Text } from '../elements/Text'

const EmptyStateFrame = styled(YStack, {
  name: 'EmptyState',
  ai: 'center',
  py: '$3xl',
  px: '$2xl',
  bg: '$backgroundCard',
  br: '$lg',
})

type EmptyStateFrameProps = GetProps<typeof EmptyStateFrame>

interface EmptyStateProps extends EmptyStateFrameProps {
  icon?: ReactNode
  title: string
  description?: string
  action?: ReactNode
}

export const EmptyState = EmptyStateFrame.styleable<EmptyStateProps>(
  ({ icon, title, description, action, ...props }, ref) => {
    return (
      <EmptyStateFrame ref={ref} {...props}>
        {icon && (
          <YStack mb="$md">
            {icon}
          </YStack>
        )}
        <Text preset="h3" align="center">
          {title}
        </Text>
        {description && (
          <Text preset="bodySmall" tone="secondary" align="center" mt="$xs">
            {description}
          </Text>
        )}
        {action && (
          <YStack mt="$xl">
            {action}
          </YStack>
        )}
      </EmptyStateFrame>
    )
  },
)
